import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { RootState } from '~/store/config';
import { IRules, ICallTaggingInfo } from '~/store/reducers/afterCallWork';
// eslint-disable-next-line import/no-cycle
import * as actions from '~/store/actions';
import api from '~/services';
import { log } from '~/helpers';
import * as actionTypes from './actionTypes';

interface IFetchAfterCallRules {
  type: string;
  payload: IRules[];
}

export const fetchAfterCallRules = () => async (
  dispatch: Dispatch<IFetchAfterCallRules>
) => {
  try {
    const rules: IRules[] = (await api.afterCallWork.get.rules())?.data;

    if (rules) {
      dispatch({
        type: actionTypes.STORE_AFTER_CALL_RULES,
        payload: rules,
      });
    }
  } catch (err) {
    log.error('Error to fetch after call work rules: ', err);
  }
};

function findTagRulesByCallInfo(
  rules: IRules[],
  callInfo: Omit<ICallTaggingInfo, 'rules'>
) {
  const { direction, queueId, outboundCli } = callInfo;

  if (queueId) {
    // eslint-disable-next-line
    for (const rule of rules) {
      if (rule.queue_id.includes(queueId)) {
        return rule;
      }
    }
  } else if (outboundCli) {
    const filteredRules = rules.filter(
      rule => rule.direction === direction || rule.direction === 'both'
    );

    // eslint-disable-next-line
    for (const rule of filteredRules) {
      if (rule.number.includes(outboundCli)) {
        return rule;
      }
    }
  }

  return undefined;
}

export const checkAndStoreMandatoryCallTagging = (
  callInfo: Omit<ICallTaggingInfo, 'rules'>
) => async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
  try {
    const { rules } = getState().afterCallWork;
    const { isBusy } = getState().system;
    const { ua } = getState().phone;

    const foundCallTagRules = findTagRulesByCallInfo(rules, callInfo);

    if (foundCallTagRules) {
      dispatch({
        type: actionTypes.STORE_MANDATORY_CALL_TAGGNING_INFO,
        payload: {
          ...callInfo,
          rules: foundCallTagRules,
        },
      });

      if (!isBusy) {
        // @ts-ignore
        dispatch(actions.setIsBusy(true));
        // @ts-ignore
        dispatch(actions.statusSystem(actionTypes.STATUS.BUSY));
        await ua?.unregister();
        dispatch({
          type: actionTypes.MANDATORY_BUSY_STATE_CHANGE,
          payload: true,
        });
      }
    }
  } catch (err) {
    log.error('Error to find mandatory call tagging:', err);
  }
};

export const expireMandatoryCallTaggingDialog = (
  callInfo: ICallTaggingInfo
) => {
  return {
    type: actionTypes.EXPIRED_OR_SUCCESS_MANDATORY_CALL_TAGGNING,
    payload: callInfo,
  };
};
